import { useEffect } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "@/components/ui/sonner";
import { api } from "@/lib/api";
import { CartProvider } from "@/context/CartContext";
import { WishlistProvider } from "@/context/WishlistContext";
import { AuthProvider } from "@/context/AuthContext";
import Header from "@/components/Header";
import AnnouncementBar from "@/components/AnnouncementBar";
import Footer from "@/components/Footer";
import CartDrawer from "@/components/CartDrawer";
import WhatsAppButton from "@/components/WhatsAppButton";
import WishlistEmailDialog from "@/components/WishlistEmailDialog";
import Home from "@/pages/Home";
import Shop from "@/pages/Shop";
import WishlistPage from "@/pages/WishlistPage";
import TrackPage from "@/pages/TrackPage";
import PageView from "@/pages/PageView";
import ProductDetail from "@/pages/ProductDetail";
import AdminGate from "@/pages/admin/AdminGate";

const FaviconSync = () => {
  useEffect(() => {
    api
      .get("/settings/site")
      .then((r) => {
        const logo = r.data.logo_url;
        if (!logo) return;
        const link =
          document.getElementById("app-favicon") ||
          (() => {
            const el = document.createElement("link");
            el.id = "app-favicon";
            el.rel = "icon";
            document.head.appendChild(el);
            return el;
          })();
        link.type = "";
        link.href = logo;
      })
      .catch(() => {});
  }, []);
  return null;
};

const ScrollToTop = () => {
  const { pathname, search } = useLocation();
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname, search]);
  return null;
};

const Storefront = () => (
  <div className="min-h-screen bg-cream">
    <div className="grain-overlay" />
    <AnnouncementBar />
    <Header />
    <Routes>
      <Route path="/" element={<Home />} />
      <Route path="/shop" element={<Shop />} />
      <Route path="/product/:id" element={<ProductDetail />} />
      <Route path="/track" element={<TrackPage />} />
      <Route path="/pages/:slug" element={<PageView />} />
      <Route path="/wishlist" element={<WishlistPage />} />
      <Route path="*" element={<Home />} />
    </Routes>
    <Footer />
    <CartDrawer />
    <WishlistEmailDialog />
    <WhatsAppButton />
  </div>
);

function App() {
  useEffect(() => {
    const lenis = new Lenis({ lerp: 0.09, smoothWheel: true });
    let rafId;
    const raf = (time) => {
      lenis.raf(time);
      rafId = requestAnimationFrame(raf);
    };
    rafId = requestAnimationFrame(raf);
    return () => {
      cancelAnimationFrame(rafId);
      lenis.destroy();
    };
  }, []);

  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <WishlistProvider>
          <CartProvider>
            <ScrollToTop />
            <FaviconSync />
            <Routes>
              <Route path="/admin" element={<AdminGate />} />
              <Route path="/*" element={<Storefront />} />
            </Routes>
            <Toaster position="top-center" richColors closeButton />
          </CartProvider>
          </WishlistProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
